import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { QuoteSearchPageInitialData } from "./quoteSearchPageInitialData";

export const QUOTE_SEARCH_PAGE_ID = "my-account/quotes/search";

export const quoteSearchPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page(QUOTE_SEARCH_PAGE_ID),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<QuoteSearchPageInitialData>>(`/page-data/${QUOTE_SEARCH_PAGE_ID}`),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
